import { motion } from 'framer-motion';
import { Sparkles, X } from 'lucide-react';
import { useState } from 'react';
import siteConfig from '@/config/siteConfig';

export const PromoBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!siteConfig.promo.enabled || !isVisible) return null;

  return (
    <motion.div
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className="fixed top-0 left-0 right-0 z-[60] bg-gradient-to-r from-accent via-accent-light to-accent py-3 px-4 shadow-gold-intense"
    >
      <div className="container-luxury flex items-center justify-center gap-3 relative">
        <Sparkles className="w-5 h-5 text-background animate-pulse" />
        <p className="text-background font-body font-bold text-sm md:text-base text-center">
          OFFRE SPÉCIALE : Jusqu'à {siteConfig.promo.maxDiscount} sur votre inscription !
        </p>
        <Sparkles className="w-5 h-5 text-background animate-pulse" />
        
        {/* Close button */}
        <button
          onClick={() => setIsVisible(false)}
          className="absolute right-0 top-1/2 -translate-y-1/2 p-1 hover:bg-background/20 rounded-full transition-colors"
        >
          <X className="w-4 h-4 text-background" />
        </button>
      </div>
    </motion.div>
  );
};

export default PromoBanner;
